import { forwardRef, type Ref, type SVGProps } from "react";

function SvgPaySuccess(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 104 120" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_pay_success)">
        <circle cx="50" cy="50" r="50" stroke="url(#paint0_linear_pay_success)" strokeWidth="20" />
        <circle cx="50" cy="50" r="50" stroke="url(#paint1_linear_pay_success)" strokeWidth="20" />
        <path
          d="M50 31.7273V28M50 65.2727V69M57.796 37.3182C56.2398 35.09 53.3313 33.5909 50 33.5909H49C44.5817 33.5909 41 36.5576 41 40.2172V40.5017C41 43.1193 42.7855 45.5122 45.6121 46.6828L54.3879 50.3172C57.2145 51.4878 59 53.8807 59 56.4983C59 60.315 55.2645 63.4091 50.6565 63.4091H50C46.6687 63.4091 43.7602 61.91 42.204 59.6818"
          stroke="#0C1C43"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_pay_success"
          x1="50"
          y1="0"
          x2="50"
          y2="100"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_pay_success"
          x1="50"
          y1="0"
          x2="50"
          y2="100"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#E5DAD3" />
        </linearGradient>
        <clipPath id="clip0_pay_success">
          <rect width="100" height="100" rx="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgPaySuccess);
export default ForwardRef;
